var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }
    },
    [
      _c("g", { attrs: { opacity: "0.3" } }, [
        _c("rect", {
          attrs: {
            x: "0.2",
            y: "0.2",
            width: "23.6",
            height: "23.6",
            rx: "2.8",
            fill: "#E6EBF0"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "0.2",
            y: "0.2",
            width: "23.6",
            height: "23.6",
            rx: "2.8",
            fill: "#C1D1E5"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "0.2",
            y: "0.2",
            width: "23.6",
            height: "23.6",
            rx: "2.8",
            stroke: "#CEDCED",
            "stroke-width": "0.4"
          }
        })
      ]),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "3.2",
          y: "3.2",
          width: "17.6",
          height: "17.6",
          rx: "1.8",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "3.2",
          y: "3.2",
          width: "17.6",
          height: "17.6",
          rx: "1.8",
          fill: "#27B8A2"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "3.2",
          y: "3.2",
          width: "17.6",
          height: "17.6",
          rx: "1.8",
          stroke: "#CEDCED",
          "stroke-width": "0.4"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M8 12.0508L11.0469 15L17 9",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b399a89", { render: render, staticRenderFns: staticRenderFns })
  }
}